<template>
  <div class="BannerContactos">
    <BannerContactos />
  </div>
  <div class="ContactosAiche">
    <contactos-aiche />
  </div>
</template>

<script>
import BannerContactos from "@/components/contactanos/BannerContactos.vue";
import ContactosAiche from "@/components/contactanos/ContactosAiche.vue";
export default { components: { BannerContactos, ContactosAiche } };
</script>

<style></style>
